module.exports = {"title":"Getting Started","body":"<p>It’s not hard, you’ve just got to give it a try!</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-keyword\">if</span> (<span class=\"hljs-literal\">true</span>) {\n  <span class=\"hljs-built_in\">console</span>.log(<span class=\"hljs-string\">'Yes I can!'</span>)\n}\n</code></pre>\n"}


//////////////////
// WEBPACK FOOTER
// ./docs/getting-started/index.md
// module id = 468
// module chunks = 0